import React from 'react';
import { useWindowScroll } from '@mantine/hooks';
import { Affix, Transition, Button } from '@mantine/core';
import IconArrowUp from '@/assets/icons/outline/arrow-up.svg?react';

import styles from './ScrollTop.module.scss';

export const ScrollTop: React.FC = () => {
	const [scroll, scrollTo] = useWindowScroll();

	const scrollToTop = () => scrollTo({ y: 0 });

	return (
		<Affix position={{ bottom: 20, right: 20 }} zIndex={50}>
			<Transition transition="slide-up" mounted={scroll.y > 600}>
				{(transitionStyles) => (
					<div style={transitionStyles}>
						<Button size="sm" className={styles.button} onClick={scrollToTop}>
							<IconArrowUp />
						</Button>
					</div>
				)}
			</Transition>
		</Affix>
	);
};
